import { List } from "immutable";
import React from "react";
import styled, { css } from "styled-components";
import { Article, ArticleSection } from "@domain/lms/article/article";
import { AttachmentSectionView } from "./attachmentSectionView";
import { DocumentSectionView } from "./documentSectionView";
import { ImageSectionView } from "./imageSectionView";
import { SubtitleSectionView } from "./subtitleSectionView";
import { TextSectionView } from "./textSectionView";
import { VideoSectionView } from "./videoSectionView";

interface ArticleContentViewerProps extends React.HTMLAttributes<HTMLDivElement> {
	article: Article;
}

interface SectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: ArticleSection;
	article: Article;
}

export const ArticleContentViewer: React.FC<ArticleContentViewerProps> = ({ article, ...htmlProps }) => {
	const sections: List<ArticleSection> = article.content.sections;
	return (
		<>
			{sections.map((section, index) => (
				<ArticleSectionShow key={index} article={article} section={section} {...htmlProps} />
			))}
		</>
	);
};

const ArticleSectionShow: React.FC<SectionViewProps> = ({ section, article, ...htmlProps }) => {
	return (
		<ArticleSectionView fullSize={section.type === "IMAGE" || section.type === "VIDEO"} {...htmlProps}>
			{section.type === "VIDEO" ? (
				<VideoSectionView section={section} article={article} />
			) : section.type === "TEXT" ? (
				<TextSectionView section={section} />
			) : section.type === "SUBTITLE" ? (
				<SubtitleSectionView section={section} />
			) : section.type === "ATTACHMENT" ? (
				<AttachmentSectionView section={section} article={article} />
			) : section.type === "PDF" ? (
				<DocumentSectionView section={section} article={article} />
			) : (
				<ImageSectionView section={section} article={article} />
			)}
		</ArticleSectionView>
	);
};

const ArticleSectionView = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "fullSize",
})<{ fullSize?: boolean }>`
	${({ fullSize }) =>
		fullSize &&
		css`
			margin-left: 50px;
			margin-right: 50px;

			@media (max-width: 900px) {
				margin-left: 16px;
				margin-right: 16px;
			}
		`}
`;
